module.exports = __webpack_public_path__ + "static/aboutsandy-credential-pccicf-min-7b3f8f758752ba7f1e416a65f468425b.png";